module.exports = __webpack_public_path__ + "static/img/A139.cc42b4c9.jpg";